// extracted by mini-css-extract-plugin
export default {"header":"header__JVCtV","show-header":"show-header__G7ANs","logo":"logo__kSFw+","love":"love__i-RXj","input":"input__cqvEr"};